import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import FloatingMenuPopup from '@/components/FloatingMenuPopup'
import { DOCUMENT_ROW_MENU_ITEMS } from './documentsRowMenuConfig'
import styles from './documentsPage.module.scss'
import { useDocumentsTableMenu } from './useDocumentsTableMenu'
import { DocumentsTableRow } from './DocumentsTableRow.jsx'

/**
 * @param {{
 *   items: import('./documentsDemoData').DocumentItem[],
 *   pickerMode?: boolean,
 *   selectedIds?: Set<string>,
 *   onToggleSelect?: (id: string) => void,
 * }} props
 */
export default function DocumentsTable({ items, pickerMode = false, selectedIds, onToggleSelect }) {
  const menu = useDocumentsTableMenu()

  return (
    <>
      <TableContainer className={styles.tableContainer}>
        <Table size="small" className={styles.tableRoot}>
          <TableHead>
            <TableRow className={styles.tableHeadRow}>
              {pickerMode ? (
                <TableCell component="th" scope="col" className={styles.thCheckbox} aria-label="Select" />
              ) : null}
              <TableCell component="th" scope="col" className={styles.thName}>
                <Typography variant="caption" color="text.secondary" className={styles.thCaption}>
                  Name
                </Typography>
              </TableCell>
              <TableCell component="th" scope="col" align="right" className={styles.thModified}>
                <Typography variant="caption" color="text.secondary" className={styles.thCaption}>
                  Modified
                </Typography>
              </TableCell>
              <TableCell component="th" scope="col" align="right" className={styles.thMeta}>
                <Typography variant="caption" color="text.secondary" className={styles.thCaption}>
                  Size
                </Typography>
              </TableCell>
              {pickerMode ? null : (
                <TableCell
                  component="th"
                  scope="col"
                  align="right"
                  aria-label="Row actions"
                  className={styles.thActions}
                />
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {items.length === 0 ? (
              <TableRow className={styles.tableRowEmpty}>
                <TableCell colSpan={pickerMode ? 4 : 4} className={styles.tdEmpty}>
                  <Typography variant="body2" color="text.secondary">
                    No documents match your search.
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              items.map((item, index) => (
                <DocumentsTableRow
                  key={item.id}
                  item={item}
                  isLast={index === items.length - 1}
                  menu={menu}
                  pickerMode={pickerMode}
                  isSelected={Boolean(selectedIds?.has(item.id))}
                  onToggleSelect={onToggleSelect}
                />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {pickerMode ? null : (
        <FloatingMenuPopup
          open={menu.openMenu}
          anchorEl={menu.menuAnchor}
          onClose={menu.handleCloseMenu}
          items={DOCUMENT_ROW_MENU_ITEMS}
          onItemSelect={menu.handleSelectMenuItem}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          menuListId="documents-row-actions-menu"
          menuListAriaLabel="Document row actions"
        />
      )}
    </>
  )
}

export { DocumentsTableRow } from './DocumentsTableRow.jsx'
